import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ResultsSection from "./components/ResultsSection";
import QuizSection from "./components/QuizSection";
import Footer from "./components/Footer";
import ThankYouPage from "./pages/ThankYouPage";

function LandingPage() {
  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <ResultsSection />
        <QuizSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
